import ResilientImage from 'components/shared/media/ResilientImage';

const ZotzonAvatar = ({ src, backupSrc = null, alt = '', style = {}, className }) => {
  return (
    <ResilientImage
      className={className}
      style={{ borderRadius: '50%', ...style }}
      src={src}
      backupSrc={backupSrc}
      alt={alt}
      preferenceKey={`avatar:${src || backupSrc || 'unknown'}`}
    />
  );
};

export default ZotzonAvatar;
